var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHelpCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C8.21997 2 6.47991 2.49852 4.99987 3.43251C3.51983 4.3665 2.36628 5.69402 1.68509 7.24719C1.0039 8.80036 0.82567 10.5094 1.17294 12.1583C1.5202 13.8071 2.37737 15.3217 3.63604 16.5104C4.89471 17.6992 6.49836 18.5087 8.24419 18.8367C9.99002 19.1646 11.7996 18.9963 13.4442 18.353C15.0887 17.7096 16.4943 16.6202 17.4832 15.2223C18.4722 13.8245 19 12.1811 19 10.5C19 8.24566 18.0518 6.08365 16.364 4.48959C14.6761 2.89553 12.3869 2 10 2Z",
    stroke: "#77787D",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 8.402C7.8125 8.402 7.84531 7.71841 8.57695 7.12974C9.01094 6.78013 9.53125 6.67896 10 6.67193C10.427 6.66646 10.8082 6.73716 11.0363 6.84576C11.427 7.03169 12.1875 7.4856 12.1875 8.45083C12.1875 9.46646 11.5234 9.92779 10.7668 10.4352C10.0102 10.9426 9.80469 11.4934 9.80469 12.0626",
    stroke: "#77787D",
    strokeWidth: 1.09375,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76562 14.875C10.1971 14.875 10.5469 14.5252 10.5469 14.0938C10.5469 13.6623 10.1971 13.3125 9.76562 13.3125C9.33415 13.3125 8.98438 13.6623 8.98438 14.0938C8.98438 14.5252 9.33415 14.875 9.76562 14.875Z",
    fill: "#77787D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHelpCircleOutline);
export default __webpack_public_path__ + "static/media/ic-help-circle-outline.597f8b3fb24dcc0f600603484a325a54.svg";
export { ForwardRef as ReactComponent };